import API_BASE_URL from '../Config';

export const getLineasCreditoPaginadas = async (token, page = 0, size = 10, search = '') => {
    const url = new URL(`${API_BASE_URL}/lineas-credito/page`);
    url.searchParams.append('page', page);
    url.searchParams.append('size', size);
    if (search) url.searchParams.append('search', search);

    const response = await fetch(url.toString(), {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar líneas de crédito paginadas');
    return response.json();
};

export const getLineaCreditoById = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/lineas-credito/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar la línea de crédito');
    return response.json();
};

export const createLineaCredito = async (token, data) => {
    const response = await fetch(`${API_BASE_URL}/lineas-credito`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al crear la línea de crédito');
    return response.json();
};

export const updateLineaCredito = async (token, id, data) => {
    const response = await fetch(`${API_BASE_URL}/lineas-credito/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al actualizar la línea de crédito');
    return response.json();
};

export const darDeBajaLineaCredito = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/lineas-credito/${id}/dar-baja`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al dar de baja la línea de crédito');
};

export const getLineasCredito = async (token) => {
    const response = await fetch(`${API_BASE_URL}/lineas-credito`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al listar líneas de crédito');
    return response.json();
};
